import { losAngelesDate } from '@evi/shared';

/**
 * The coupon form's date fields (Warren, 29 Oct 2026): "Valid until" is the
 * end of that day, 23:59:59 Los Angeles time, and "Valid from" the start of
 * its day. The Api turns the YYYY-MM-DD the form sends into those instants
 * (@evi/shared promotionDates.ts); this side only shows and sends the day.
 */

/** The date input's value for a stored coupon date: its Los Angeles day.
 *  Never `.slice(0, 10)` of the stored instant: that is the UTC date, the
 *  next day for every coupon that ends at 23:59:59 Los Angeles time, and
 *  saving it back would move the end a day later. */
export function couponDateInput(iso: string | null | undefined): string {
  if (!iso) return '';
  try { return losAngelesDate(iso); } catch { return ''; }
}

/** What the form sends for a date field. A create sends the day or nothing.
 *  An edit sends it only when the admin changed it ('' clears the date), so
 *  saving another field never re-sends, and never moves, a stored date. */
export function couponDatePayload(value: string, initial: string, editing: boolean): string | undefined {
  if (!editing) return value || undefined;
  return value !== initial ? value : undefined;
}
